const SITE_KEY = import.meta.env.VITE_RECAPTCHA_KEY;

let loadPromise = null;

export function loadRecaptcha() {
	if (typeof window === "undefined") {
		return Promise.reject(new Error("No window"));
	}
	if (window.grecaptcha) return Promise.resolve();
	if (loadPromise) return loadPromise;

	if (!SITE_KEY) {
		return Promise.reject(new Error("RECAPTCHA site key is missing"));
	}

	loadPromise = new Promise((resolve, reject) => {
		const fail = err => {
			loadPromise = null;
			reject(err);
		};

		const id = "grecaptcha-v3";

		const waitReady = () => {
			let done = false;
			const onReady = () => {
				if (done) return;
				done = true;
				resolve();
			};
			try {
				window.grecaptcha.ready(onReady);
				setTimeout(() => {
					if (!done) fail(new Error("grecaptcha.ready timeout"));
				}, 8000);
			} catch (e) {
				fail(new Error("grecaptcha.ready failed"));
			}
		};

		// Reaching here means window.grecaptcha is absent, so a tag already in the page is
		// a failed load; left in place it would block every retry until a reload.
		document.getElementById(id)?.remove();

		const s = document.createElement("script");
		s.id = id;
		s.async = true;
		s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
		s.onload = waitReady;
		s.onerror = () => {
			s.remove();
			fail(new Error("Failed to load api.js"));
		};
		document.head.appendChild(s);
	});

	return loadPromise;
}

export async function getRecaptchaToken(action = "GLOBAL_PROTECTED") {
	await loadRecaptcha();
	await new Promise((resolve, reject) => {
		if (!window.grecaptcha?.ready) return reject(new Error("grecaptcha not available"));
		window.grecaptcha.ready(resolve);
	});
	try {
		const token = await window.grecaptcha.execute(SITE_KEY, { action });
		if (!token) throw new Error("reCAPTCHA returned empty token");
		return token;
	} catch (e) {
		const err = e instanceof Error ? e : new Error(String(e));
		err.name = "RecaptchaError";
		throw err;
	}
}
